import {ReactComponent as HubShirazIcon} from './hubShiraz.svg'

function HubShiraz() {
  return <HubShirazIcon />
}

export default HubShiraz
